<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import { sessionHelper, ddlHelper } from "@/utils";
import { SESSION } from "@/constants";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from "@/i18n";
import { DOMAIN_GROUP_MODULE } from '@/state/modules/domainGroup'
import { domainGroupMethods } from "@/state/helpers";

// Lowercase letters, digits and dashes; empty means "let the backend derive it".
const slug = (value) => {
  if (value == null || value == '') {
    return true;
  }
  return /^[a-z0-9]+(-[a-z0-9]+)*$/.test(value);
};

export default {
  page: {
    title: i18n.t("label.createX", [i18n.t("module.domainGroup")]),
  },
  components: { Layout, PageHeader, Multiselect },
  beforeRouteLeave(to, from, next) {
    if (to.name != "Domain-group-listing") {
      sessionHelper.clearSearch(SESSION.DOMAIN_GROUP_SEARCH);
    }
    next();
  },
  computed: {
    selectedCountry: {
      get() {
        return this.countryDdl.find((c) => c.value === this.createForm.countryCode) || null;
      },
      set(option) {
        this.createForm.countryCode = option ? option.value : null;
      },
    },
    ...mapState(DOMAIN_GROUP_MODULE, ["status"]),
  },
  data() {
    return {
      title: i18n.t("label.createX", [i18n.t("module.domainGroup")]),
      items: [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.domainGroup"),
          href: "/domain-group",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.domainGroup")]),
          active: true,
        },
      ],
      submitted: false,
      permissions: sessionHelper.getPermissions(),
      createPermission: null,
      readAllPermission: null,
      // Groups exist for AU and MY only, cut down to the markets this user may see.
      countryDdl: ddlHelper.getMonitorCountries(['AU', 'MY']),
      createForm: {
        name: "",
        slug: "",
        countryCode: sessionHelper.canSeeCountry("AU") ? "AU" : (ddlHelper.getMonitorCountries(['AU', 'MY'])[0] || {}).value || null,
      },
    };
  },
  validations: {
    createForm: {
      name: { required },
      slug: { slug },
      countryCode: { required },
    },
  },
  async created() {
    await this.validPermissions();
  },
  methods: {
    ...domainGroupMethods,
    async validPermissions() {
      var jsonPermissions = JSON.parse(this.permissions)
      this.createPermission = jsonPermissions.some(p => p.code === "DOMAIN_CREATE");
      this.readAllPermission = jsonPermissions.some(p => p.code === "DOMAIN_READ_ALL");
    },
    normalizeSlug() {
      this.createForm.slug = (this.createForm.slug || '').trim().toLowerCase();
    },
    requestCreate() {
      this.normalizeSlug();
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        let data = {
          name: this.createForm.name,
          slug: this.createForm.slug,
          countryCode: this.createForm.countryCode,
        };

        if (this.createPermission == true) {
          this.createDomainGroup({ data });
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="requestCreate" v-if="createPermission == true">
              <b-form-group id="name" label-cols-sm="2" label-cols-lg="2" :label="$t('label.name')" label-for="name">
                <b-form-input for="name" v-model.trim="createForm.name"
                  :class="{ 'is-invalid': submitted && !$v.createForm.name.required }"></b-form-input>
                <div v-if="submitted && !$v.createForm.name.required" class="invalid-feedback">
                  <span>{{ $t("message.requiredX", [$t("label.name")]) }}</span>
                </div>
              </b-form-group>

              <b-form-group id="slug" label-cols-sm="2" label-cols-lg="2" :label="$t('label.slug')" label-for="slug">
                <b-form-input for="slug" v-model.trim="createForm.slug" @change="normalizeSlug"
                  :class="{ 'is-invalid': submitted && !$v.createForm.slug.slug }"></b-form-input>
                <div v-if="submitted && !$v.createForm.slug.slug" class="invalid-feedback">
                  <span>{{ $t("message.validX", [$t("label.slug")]) }}</span>
                </div>
                <small class="form-text text-muted">{{ $t('message.slugHelp') }}</small>
              </b-form-group>

              <b-form-group id="countryCode" label-cols-sm="2" label-cols-lg="2" :label="$t('label.countryCode')"
                label-for="countryCode">
                <multiselect v-model="selectedCountry" :options="countryDdl" label="text" track-by="value"
                  :show-labels="false" :allow-empty="false"
                  :class="{ 'is-invalid': submitted && !$v.createForm.countryCode.required }"></multiselect>
                <div v-if="submitted && !$v.createForm.countryCode.required" class="invalid-feedback">
                  <span>{{ $t("message.requiredX", [$t("label.countryCode")]) }}</span>
                </div>
                <small class="form-text text-muted">{{ $t('message.groupCountryHelp') }}</small>
              </b-form-group>

              <div class="mt-4 text-center" style="float: right">
                <button class="btn btn-info w-md waves-effect waves-light" style="margin-right: 10px" type="submit"
                  :disabled="status.processing">
                  {{ $t("label.createX", [$t("module.domainGroup")]) }}
                </button>
              </div>
            </form>
            <div style="text-align: center;" v-else>
              {{ $t('message.noPermissionMessage') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
